import {
  init,
  isInitialized,
  setUser,
  browserTracingIntegration,
  consoleLoggingIntegration,
  extraErrorDataIntegration,
} from '@sentry/react';
import { log, LogLevelDesc } from '@quoruum/frontend-common/logger';

export const initializeSentryForFrontend = (
  user: { id: string; name: string },
  logLevel: LogLevelDesc,
  dsn?: string
): void => {
  if (!dsn) {
    log.debug('Sentry DSN not provided, skipping Sentry initialization for frontend');
    return;
  }

  if (isInitialized()) {
    log.debug('Sentry is already initialized, skipping re-initialization');
    return;
  }

  init({
    dsn,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#dataCollection
    dataCollection: {},
    integrations: [
      // TODO NAR revisit comment below
      // If you're using react router, use the integration for your react router version instead.
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      browserTracingIntegration(),
      consoleLoggingIntegration(),
      extraErrorDataIntegration(),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', 'https://api.quoruum.com'],
  });

  setUser({
    id: user.id,
    username: user.name,
  });

  log.setLevel(logLevel, false);
};
